import type { FC } from "react";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Goal, goalToString } from "shared";
import { useForm } from "../../common/form/useForm";
import { Modal, useModal } from "../../common/modal/Modal";
import { useCompany, useCompanyActions } from "../../company/useCompany";
import { useMarketingPlanActions } from "../../company/useMarketingPlan";
import { Button } from "../../components/Button";
import { LinkGen } from "../../LinkGen";

type Props = {
	onSuccess?: () => Promise<unknown>;
};

export const ModalGoal: FC<Readonly<Props>> = ({ onSuccess }) => {
	const company = useCompany();
	const { updateCompany } = useCompanyActions();
	const { generatePlan } = useMarketingPlanActions();
	const { close } = useModal();
	const navigate = useNavigate();

	const form = useForm({
		initialValues: {
			goal: company?.goal ?? Goal.LAUNCHING_BUSINESS,
		},
		onSubmit: async (values) => {
			await updateCompany.mutateAsync({
				goal: values.goal,
			});

			await generatePlan.mutateAsync().then(() => {
				navigate(LinkGen.Calendar());
			});

			onSuccess?.();
			close();
		},
	});

	return (
		<Modal size="lg">
			<h2>What is you business goal for the next 12 months?</h2>

			<Form onSubmit={form.handleSubmit}>
				<div className="my-3">
					<Form.Group>
						{Object.values(Goal).map((goal) => (
							<Form.Check
								key={goal}
								id={goal}
								type="radio"
								label={goalToString[goal]}
								checked={form.values.goal === goal}
								{...form.getFieldProps("goal")}
								{...form.getFieldState("goal")}
								value={goal}
							/>
						))}

						<Button
							variant="primary"
							full
							type="submit"
							className="mt-3"
							loading={generatePlan.isPending}
						>
							Create Marketing Plan
						</Button>
						<Button variant="link" full onClick={close} className="mt-3">
							Back
						</Button>
					</Form.Group>
				</div>
			</Form>
		</Modal>
	);
};
